<template>
    <div>
        <b-row no-gutters>
            <b-col md="12" class="heig-frame-child">
                <gofix-card class="mb-0 heig-frame-child" fullContent>
                    <gofix-default-table :settings="tableConfig"
                        :table-items="tableItems"
                        @load-items="getTableData"
                        @row-click="clickToRowItem"
                        @new-item="newItem"
                        @delete-items="deleteItems"
                        @export="exportItems"
                        @change-selected="hanldeSaveIds"
                        ref="gofixTable">
                        <template slot="gofix_table:submitted_at" slot-scope="row">
                            {{row.item.submitted_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:created_at" slot-scope="row">
                            {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:updated_at" slot-scope="row">
                            {{row.item.updated_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                        </template>
                        <template slot="gofix_table:actions" slot-scope="row" v-if="status == 'all' && row.item.status != 'New'">
                            <b-form-checkbox disabled></b-form-checkbox>
                        </template>
                        <template slot="gofix_table:before-control-right" v-if="status != 'all'">
                            <gofix-button id="gofix-button-mass" class="ml-2" label="Download Report" @click="hanldeMultipleReport" outline></gofix-button>
                        </template> 
                    </gofix-default-table>
                </gofix-card>
            </b-col>
        </b-row>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Safety Inspection" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <dropdown-projects
                            required
                            show-icon-required
                            @setDefaultValue="setDefaultProject"
                            v-model="modals.add.data.project">
                        </dropdown-projects>
                        <gofix-form-dropdown
                            label="BU"
                            vLabel="reference_value_text"
                            :reduce="option => option.reference_value_text"
                            v-model="modals.add.data.description"
                            :options="modals.add.options.project_descriptions">
                        </gofix-form-dropdown>
                        <dropdown-companies 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.add.data.company">
                        </dropdown-companies>
                        <dropdown-user-duties 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            :company-id="modals.add.data.company && modals.add.data.company.id ? modals.add.data.company.id : null"
                            required
                            show-icon-required
                            role-name="Contractor Supervisor"
                            :reduce="option => option.user_id"
                            v-model="modals.add.data.contractor_supervisor_id">
                        </dropdown-user-duties>
                        <dropdown-locations 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.add.data.equipment">
                        </dropdown-locations>
                        <dropdown-user-duties 
                            label="Participating Inspectors"
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            :company-id="modals.add.data.company && modals.add.data.company.id ? modals.add.data.company.id : null"
                            :exclude-id="modals.add.data.contractor_supervisor_id"
                            :reduce="option => option.user_id"
                            v-model="modals.add.data.participating_inspector_by_id">
                        </dropdown-user-duties>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import DropdownProjects from '../elements/DropdownProjects.vue'
import DropdownLocations from '../elements/DropdownLocations.vue'
import DropdownCompanies from '../elements/DropdownCompanies.vue'
import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
import moment from 'moment'
export default {
    name: 'SafetyInspectionChecklist',
    components: {
        DropdownProjects,
        DropdownLocations,
        DropdownCompanies,
        DropdownUserDuties
    },
    props: {
        status: {
            type: String,
            default: 'all'
        },
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_inspection_checklist']));
        const nameComponent = this.status == 'Completed' ? "safety-inspection-checklist-completed" : "";
        let option_status = [
            {value: 'New', text: 'New'},
            {value: 'Submitted', text: 'Submitted'},
            {value: 'Contractor Acknowledged', text: 'Contractor Acknowledged'},
            {value: 'Completed', text: 'Completed'},
        ];
        if(this.status == 'Completed') {
            option_status = [
                {value: 'Completed', text: 'Completed'},
            ];
        }
        return {
            tableConfig:{
                name: 'safety-inspection-checklist-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.safety_inspection_checklist, 'create'),
                    delete: this.status == 'all' ? this.$checkRole(this.$accessModule.safety_inspection_checklist, 'delete') : false,
                    tableImport: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: option_status,
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
                nameComponent: nameComponent,
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        equipment: null,
                        company: null,
                        contractor_supervisor_id: null,
                        participating_inspector_by_id: null,
                        description: null
                    },
                    options: {
                        project_descriptions: [],
                    }
                }
            },
            timer: {
                save: null,
                report: null
            },
            safety_ids: []
        }
    },
    computed: {
    },
    watch: {
        "modals.add.data.contractor_supervisor_id": function(val) {
            if(val && val == this.modals.add.data.participating_inspector_by_id) {
                this.modals.add.data.participating_inspector_by_id = null
            }
        }, 
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                if(this.status == 'Completed') {
                    tableRequest.filter.status.value = ['Completed'];
                }
                await this.$store.dispatch("SafetyAppController/getSafetyInspectionChecklistItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of safety inspection", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
           this.$router.push(`/v2/safety-inspection-checklist/${item.id}`)
        },
        async newItem() {
            this.modals.add.data = {
                project: null,
                equipment: null,
                company: null,
                contractor_supervisor_id: null,
                participating_inspector_by_id: null
            };

            this.modals.add.open = true;
        },
        setDefaultProject(val) {
            this.modals.add.data.project = val
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteSafetyInspectionItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'safe_inspection_checklist'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems(tableRequest) {
            let request = JSON.parse(JSON.stringify(tableRequest));
            request.limit = -1;
            this.$store.dispatch( 'SafetyAppController/exportSafetyInspections', request)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'SafetyInspections.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                const validate_fields = [
                    { key: 'project', name: 'Project'},
                    { key: 'company', name: 'Subcontractor'},
                    { key: 'contractor_supervisor_id', name: 'Subcontractor Supervisor'},
                    { key: 'equipment', name: 'Location'},
                ]

                const is_validate = this.$validationData(validate_fields, this.modals.add.data)
                if(is_validate) return

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    project_id: this.modals.add.data.project.id,
                    location_id: this.modals.add.data.equipment.location_id,
                    location: this.modals.add.data.equipment.name,
                    equipment_id: this.modals.add.data.equipment.equipment_id,
                    equipment_lift_number: this.modals.add.data.equipment.equipment_lift_number,
                    equipment_type: this.modals.add.data.equipment.equipment_type,
                    supplier_id: this.modals.add.data.company && this.modals.add.data.company.id ? this.modals.add.data.company.id : null,
                    supplier: this.modals.add.data.company && this.modals.add.data.company.name ? this.modals.add.data.company.name : null,
                    participating_inspector_by_id: this.modals.add.data.participating_inspector_by_id,
                    contractor_supervisor_id: this.modals.add.data.contractor_supervisor_id,
                    description: this.modals.add.data.description,
                };
                
                this.$store.dispatch("SafetyAppController/createSafetyInspectionItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/safety-inspection-checklist/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'safe_inspection_checklist'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        },
        getProjectDescriptions(){
            let filter = {reference_type: "Safety Project Description"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.project_descriptions = response.items;
                })
        },
        hanldeSaveIds(ids) {
            this.safety_ids = ids;
        },
        hanldeMultipleReport() {
            if (this.timer.report) {
                    clearTimeout(this.timer.report);
                    this.timer.report = null;
                }
                this.timer.report = setTimeout(() => {
                    if(this.safety_ids.length == 0) {
                        this.$alertNotification("Please select at least one item to download report", "warning");
                        return;
                    }

                    let nameFile = `report-${moment().format('DD-MMM-YYYY')}.zip`;
                    this.$store.dispatch("SafetyAppController/reportMultipleSafetyInspectionChecklistItem", this.safety_ids)
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nameFile);
                        document.body.appendChild(link);
                        link.click();
                    });
                }, 300);
        }
    },
    created() {
        this.getProjectDescriptions();
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
.tooltip {
    max-width: 400px;
}
</style>